<!-- PdfPreview.vue -->
<template>
  <a-modal
    width="auto"
    :visible="visible"
    @cancel="visible = false"
  >
    <!-- PDF 预览模态框 -->
    <div class="pdf-preview-modal">
      <div class="pdf-header">
        <button class="pdf-back-btn" @click="closePdf">返回</button>
        <h3>PDF 预览</h3>
        <div class="pdf-page-info">
          第 {{ currentPage }} 页，共 {{ pageCount }} 页
        </div>
      </div>

      <div class="pdf-body" ref="pdfContainer">
        <template v-if="loading">
          <div class="pdf-loading">加载中...</div>
        </template>

        <pdf
          :src="pdfUrl"
          :page="currentPage"
          @num-pages="pageCount = $event"
          @page-loaded="currentPage = $event"          
          class="pdf-embed"
          @loaded="onPdfLoaded"            
          ref="pdfComponent"
          :scale="'page-width'" 
        ></pdf>
      </div>

      <div class="pdf-footer">
        <button @click="changePage(currentPage - 1)" :disabled="currentPage <= 1">
          上一页
        </button>
        <span>{{ currentPage }} / {{ pageCount }}</span>
        <button @click="changePage(currentPage + 1)" :disabled="currentPage >= pageCount">
          下一页
        </button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'PdfPreview',
  components: {
    pdf
  },
  data() {
    return {
      pdfUrl: '',              // PDF 文件地址
      pageCount: 1,            // 总页数
      currentPage: 1,          // 当前页
      loading: true,           // 加载状态
      visible: false,
      pdfKey: 0,               // vue-pdf key，用于强制刷新组件      
    }
  },
  methods: {
    onPdfLoaded() {
        this.loading = false;

        // PDF 元数据加载完成，再次触发 resize 确保正确缩放
        this.$nextTick(() => {
            window.dispatchEvent(new Event('resize'));
        });
    },
    openPdf(url) {
      const loadingTask = pdf.createLoadingTask(url)
      this.pdfUrl = loadingTask
    //   this.pdfUrl = url
      this.visible = true
      this.loading = true
      this.currentPage = 1
      this.pageCount = 1
      this.$nextTick(() => {
            // 延迟一点，确保 flex 布局完成（关键！）
            setTimeout(() => {
            // 触发 pdf.js 重新计算尺寸
            window.dispatchEvent(new Event('resize'));

            // 可选：手动调用 vue-pdf 的 render 方法（如果暴露了）
            // this.$refs.pdfComponent.$el?.dispatchEvent?.(new Event('resize'))
            }, 500); // 100ms 通常足够布局完成
        });
    },
    closePdf() {
      this.visible = false
      this.pdfUrl = ''
      this.loading = true
      this.currentPage = 1
      this.pageCount = 1
    },
    changePage(page) {
      if (page >= 1 && page <= this.pageCount) {
        this.currentPage = page
      }
    }
  }
}
</script>

<style scoped>
.file-list {
  padding: 20px;
}

.file-list ul {
  list-style: none;
  padding: 0;
}

.file-list li {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.pdf-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh; /* 明确高度 */
  background: #fff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  font-family: Arial, sans-serif;
}

.pdf-header {
  padding: 12px 16px;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pdf-back-btn {
  padding: 8px 12px;
  background: #2b5e7d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pdf-back-btn:disabled {
  background: #ccc;
}

.pdf-page-info {
  font-size: 14px;
  color: #555;
}

.pdf-body {
  flex: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px 0;
  background: #f0f0f0;
  min-height: 0;
}
.pdf-embed {
  max-width: 100%;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.pdf-loading {
  padding: 20px;
  font-size: 16px;
  color: #666;
}

.pdf-footer {
  padding: 12px 16px;
  background: #f5f5f5;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.pdf-footer button {
  padding: 8px 16px;
  background: #2b5e7d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pdf-footer button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* 响应式：适配平板和手机 */
@media (max-width: 768px) {
  .pdf-header, .pdf-footer {
    flex-direction: row;
    gap: 10px;
  }
  .pdf-header h3, .pdf-footer span {
    font-size: 14px;
  }
}
</style>